import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://hbnnicrtuqayixqtcqrd.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'sb_publishable_YHYHoKoV136cH0tqU-i28Q_zmjle4WE';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
